import Vue from 'vue';
import Buefy from 'buefy';

import Profile from './App.vue'



Vue.use(Buefy, {
    defaultIconPack: 'fas',
  })
Vue.use(Profile)

if(document.getElementById("userProfileApp")){
    new Vue({
        render: h => h(Profile,{
            props:{
                profileEndpoint:document.getElementById("userProfileApp")
                    .getAttribute("profile"),
                user: document.getElementById("userProfileApp")
                    .getAttribute("user"),
                countryList: document.getElementById("userProfileApp")
                    .getAttribute("country-list")
            }
        })
    }).$mount("#userProfileApp")
}